import React from 'react';
import classNames from 'classnames';

const TBody = ({ className = '', children }) => {
	return <tbody className={classNames('table-body', className)}>{children}</tbody>;
};

export default TBody;
